import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderThemeTabsComponent } from './header-theme-tabs.component';

@NgModule({
  declarations: [HeaderThemeTabsComponent],
  imports: [CommonModule],
  exports: [HeaderThemeTabsComponent],
})
export class HeaderThemeTabsModule {}
